import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.5 12.9c1.323 0 2.4-1.077 2.4-2.4s-1.077-2.4-2.4-2.4-2.4 1.077-2.4 2.4 1.077 2.4 2.4 2.4zm0-4c.882 0 1.6.718 1.6 1.6s-.718 1.6-1.6 1.6-1.6-.718-1.6-1.6.718-1.6 1.6-1.6zM6.691 15l4.809 9.618L16.309 15H6.691zm1.618 1h6.383L11.5 22.382 8.309 16zM20.5 14.382 15.691 24h9.617L20.5 14.382zm0 2.236L23.691 23h-6.383l3.192-6.382zm0-3.718c1.323 0 2.4-1.077 2.4-2.4s-1.077-2.4-2.4-2.4-2.4 1.077-2.4 2.4 1.077 2.4 2.4 2.4zm0-4c.882 0 1.6.718 1.6 1.6s-.718 1.6-1.6 1.6-1.6-.718-1.6-1.6.718-1.6 1.6-1.6z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;